import React from 'react';
import { FaEnvelope, FaLinkedin, FaGithub, FaFileDownload } from 'react-icons/fa';

const channels = [
  {
    label: 'Email',
    value: 'thanushanx@gmail.com',
    href: 'mailto:thanushanx@gmail.com',
    icon: FaEnvelope,
  },
  {
    label: 'LinkedIn',
    value: 'linkedin.com/in/shan-v',
    href: 'https://www.linkedin.com/in/shan-v/',
    icon: FaLinkedin,
  },
  {
    label: 'GitHub',
    value: 'github.com/Shan-V',
    href: 'https://github.com/Shan-V',
    icon: FaGithub,
  },
  {
    label: 'Resume',
    value: 'Download PDF',
    href: '/Thanushan_Varatharajah_Resume.pdf',
    icon: FaFileDownload,
    download: true,
  },
];

const Contact = () => {
  return (
    <section name='contact' className='w-full py-24 sm:py-32 bg-bg-alt'>
      <div className='container-narrow text-center'>
        <p className='section-eyebrow'>05. What's next?</p>
        <h2 className='section-title'>Get in touch</h2>
        <div className='w-12 h-1 bg-accent rounded-full mx-auto mb-8' />

        <p className='text-zinc-400 max-w-xl mx-auto mb-12 leading-relaxed'>
          I'm currently open to senior SDET and backend engineering roles. Whether you have
          a question about test automation, a Spring Boot codebase that needs coverage, or
          just want to say hello — I'll get back to you.
        </p>

        <div className='grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-12'>
          {channels.map((c) => {
            const Icon = c.icon;
            return (
              <a
                key={c.label}
                href={c.href}
                target={c.download ? '_blank' : c.href.startsWith('http') ? '_blank' : undefined}
                rel='noopener noreferrer'
                className='group flex flex-col items-center gap-2 rounded-xl border border-zinc-800 bg-bg-elev p-6 hover:border-accent/50 hover:-translate-y-1 transition-all duration-200'
              >
                <Icon className='text-accent text-2xl mb-1' />
                <span className='font-mono text-zinc-500 text-xs uppercase tracking-widest'>{c.label}</span>
                <span className='text-zinc-300 text-sm font-medium break-all'>{c.value}</span>
              </a>
            );
          })}
        </div>

        <a href='mailto:thanushanx@gmail.com' className='btn-primary'>
          <FaEnvelope /> Say hello
        </a>
      </div>

      <footer className='mt-24 text-center text-zinc-600 text-xs font-mono'>
        Built with React &amp; Tailwind by Shan &middot; {new Date().getFullYear()}
      </footer>
    </section>
  );
};

export default Contact;
